'use client'

import Link from 'next/link'
import { Menu, X, ArrowUpRight } from 'lucide-react'
import { Logo } from '@/shared/components/layout/logo'
import { useHeaderAfterStory, useLandingMenu } from '../hooks/use-landing'
import s from '../styles/landing.module.css'

const links = [ ['Hikâyemiz', '#history'], ['Yapay zekâ', '#yapay-zeka'], ['Çalışma alanı', '#flow'], ['Fiyatlandırma', '#pricing'] ]

export function EditorialHeader({ isHome = true, isLogin = false }: { isHome?: boolean; isLogin?: boolean }) {
  const { open, close, toggle, buttonRef } = useLandingMenu()
  const afterStory = useHeaderAfterStory()
  return <header className={s.header} data-after-story={isHome && afterStory} data-public={!isHome}>
    <a className={s.skipLink} href={isHome ? "#features" : "#public-content"}>İçeriğe geç</a>
    <Link href="/" className={s.brand} aria-label="Muhasebe AI ana sayfa"><Logo size="sm" /></Link>
    <nav className={s.desktopNav} aria-label="Ana menü">{links.map(([label, href]) => <Link key={href} href={isHome ? href : `/${href}`}>{label}</Link>)}</nav>
    <div className={s.headerActions}>
      <Link className={s.loginLink} href={isLogin ? "/kayit" : "/login"}>{isLogin ? "Hesap oluştur" : "Giriş yap"} <ArrowUpRight size={16} /></Link>
      <button type="button" ref={buttonRef} className={s.menuButton} aria-expanded={open} aria-controls="landing-menu" aria-label={open ? 'Menüyü kapat' : 'Menüyü aç'} onClick={toggle}>{open ? <X size={22} /> : <Menu size={22} />}</button>
    </div>
    {open && <nav id="landing-menu" className={s.mobileNav} aria-label="Mobil menü">{links.map(([label, href]) => <Link key={href} href={isHome ? href : `/${href}`} onClick={close}>{label}<ArrowUpRight size={18} /></Link>)}<Link href="/kayit" onClick={close}>Hesap oluştur<ArrowUpRight size={18} /></Link></nav>}
  </header>
}
